import { render } from "./Initial.vue?vue&type=template&id=57776ee0&scoped=true"
import script from "./Initial.vue?vue&type=script&lang=js"
export * from "./Initial.vue?vue&type=script&lang=js"

import "./Initial.vue?vue&type=style&index=0&id=57776ee0&lang=scss"
import "./Initial.vue?vue&type=style&index=1&id=57776ee0&scoped=true&lang=css"

import exportComponent from "/var/www/app/app-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57776ee0"]])

export default __exports__